export enum MagicLinkStatusEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum MagicLinkOriginEnum {
  STUDY_REEL = 'STUDY_REEL',
}

export interface MagicLinkTokenRequest {
  magicToken: string;
}

export interface MagicLinkTokenResponse {
  AccessToken: string;
  ExpiresIn: number;
  TokenType: string;
  RefreshToken: string;
  IdToken: string;
}
